if (typeof window.__postMessageToHBuilderX__ !== 'function') {
    window.__postMessageToHBuilderX__ = function __postMessageToHBuilderX__(data: string) {
        console.log('__postMessageToHBuilderX__', JSON.stringify(data))
    }
}
export function publish(action: string, data?: object, reqId: number = -1) {
    window.__postMessageToHBuilderX__(JSON.stringify({
        reqId,
        response: {
            action,
            data: data || {}
        }
    }))
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge/publish.ts